// Remove dotenv import - Vue CLI handles environment variables automatically

export default class Configuration {
    static get EnvConfig() {
        return {
            rootApi: '$VUE_APP_ROOT_API',
        }
    }

    static value(key) {
        // If the key does not exist in the EnvConfig object of the class, return null
        if (!Object.prototype.hasOwnProperty.call(this.EnvConfig, key)) {
            console.error(`Configuration: There is no key named "${key}". Please add it in Configuration class.`);
            return null;
        }

        // Get the value
        const value = this.EnvConfig[key];

        // If the value is null or undefined, return null
        if (!value) {
            console.error(`Configuration: Value for "${key}" is not defined`);
            return null;
        }

        if (!value.startsWith('$VUE_APP_')) {
            // value was already replaced, it seems we are in production (containerized).
            return value;
        }

        // value was not replaced, it seems we are in development.
        const envName = value.substr(1); // Remove $ and get current value from process.env
        const envValue = process.env[envName];

        if (!envValue) {
            console.error(`Configuration: Environment variable "${envName}" is not defined`);
            return null;
        }

        return envValue;
    }
}